import React, { useEffect, useState, useCallback, useRef } from "react";
import useHttp from "../hooks/use-http";
import { Cookies } from "react-cookie";
import useCookies from "react-cookie/cjs/useCookies";
import { parseCookies } from "nookies";

const AppContext = React.createContext({
  envProp: {},
  bioradResources: {},
  country: "US",
  lang: "en",
  expanded: "",
  setExpanded: () => {},
  quoteItemList: [],
  setQuoteItemList: () => {},
});

export const AppContextProvider = (props) => {
  const [envProp, setEnvProp] = useState({});
  const [bioradResources, setBioradResources] = useState({});
  const [expanded, setExpanded] = useState(null);
  const [quoteItemList, setQuoteItemList] = useState({});
  const {
    isLoadingBioradResources,
    errorGetBioradResources,
    sendRequest: getBioradResources,
  } = useHttp();
  const [cookies, setCookie, removeCookie] = useCookies(["evCntryLang"]);
  const cookiess = parseCookies();
  const hasRun = useRef(false);

  const countryLang = cookies.evCntryLang
    ? cookies.evCntryLang.split("-")
    : ["US", "en"];
  const country = countryLang[0];
  const lang = countryLang[1];
  const locale = lang + "_" + country;

  const fetchEnvPropJSON = useCallback(() => {
    fetch("/envprop.json")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setEnvProp(data);
      })
      .catch((error) => {
        console.log(error);
      });
  });

  const fetchBioradResources = () => {};

  useEffect(() => {
    fetchEnvPropJSON();
  }, []);

  useEffect(() => {
    if (!envProp || !envProp.appServer || !locale) {
      return;
    }
    const bioradResourcesURL =
      envProp.appServer +
      "brcapi/rb/properties.Sterling,com.comergent.reference.jsp.BioradResources/" +
      locale;
    const setBioradResourcesData = (data) => {
      setBioradResources(data);
    };
    const newBrandStyle = cookiess.rebrandEnabled
    ? cookiess.rebrandEnabled === "true"
    : envProp?.react_app_new_brand_style == "true";
    const dropdownScript = document.createElement('script');

    if (newBrandStyle) {
      import("../AppBrand.css");
      dropdownScript.src = `${process.env.PUBLIC_URL}/js/GlobalBrand.js`;
    } else {
      import("../App.css");
      dropdownScript.src = `${process.env.PUBLIC_URL}/js/Global.js`;
    }

    document.head.appendChild(dropdownScript);
    getBioradResources(
      { url: bioradResourcesURL },
      setBioradResourcesData,
      "json"
    ).catch((error) => {
      console.log("Error getting biorad resources");
    });
  }, [envProp, locale]);

  return (
    <AppContext.Provider
      value={{
        envProp: envProp,
        bioradResources: bioradResources,
        country: country,
        lang: lang,
        expanded,
        setExpanded,
        quoteItemList,
        setQuoteItemList,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContext;
